import React, { useCallback, useMemo } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExtendLocationCreativeHeaderBase from "./ExtendLocationCreativeHeader";
import CreativeViewBase from "./CreativeView";
import OtherDetailsBase from "./OtherDetails";

type LocationId = number | string;

type CreativeSelectionLocation = {
  id: LocationId;
  location_name?: string;
  packages_data?: unknown[];
  [key: string]: unknown;
};

type LocationCreativeState = {
  can_update_creatives?: boolean;
  [key: string]: unknown;
};

type ExtendCampaignData = {
  creative_select_max_value?: number | string | null;
};

type CreativeSelectionFormProps = {
  location_id: LocationId;
  lc: LocationCreativeState;
  loc: CreativeSelectionLocation;
  campaignData?: ExtendCampaignData;
  expanded: LocationId[];
  setExpanded: React.Dispatch<React.SetStateAction<LocationId[]>>;
};

const ExtendLocationCreativeHeader =
  ExtendLocationCreativeHeaderBase as React.ComponentType<
    Record<string, unknown>
  >;

const CreativeView = CreativeViewBase as unknown as React.ComponentType<
  Record<string, unknown>
>;

const OtherDetails = OtherDetailsBase as React.ComponentType<
  Record<string, unknown>
>;

function CreativeSelectionForm({
  location_id,
  lc,
  loc,
  campaignData,
  expanded,
  setExpanded,
}: CreativeSelectionFormProps) {
  const isEligible = lc?.can_update_creatives !== false;

  const shouldExpandIt = useMemo(() => {
    return isEligible && expanded.includes(location_id);
  }, [expanded, location_id, isEligible]);

  const handleOnExpand = useCallback(
    (locationId: LocationId) => (_event: unknown, isExpanded: boolean) => {
      if (!isEligible) {
        return;
      }

      if (isExpanded) {
        setExpanded((prev) => [...new Set([...prev, locationId])]);
      } else {
        setExpanded((prev) => prev.filter((id) => id !== locationId));
      }
    },
    [setExpanded, isEligible]
  );
  return (
    <div>
      <Accordion
        expanded={shouldExpandIt}
        onChange={handleOnExpand(location_id)}
        // className={`location ${loc?.isPastDue ? "past_due" : ""}`}
        // onFocus={() => {
        //   onFocus?.();
        // }}
        // onBlur={() => {
        //   onBlur?.();
        // }}
        className="mb-2"
        elevation={2}
      >
        <AccordionSummary
          expandIcon={
            <ChevronRightIcon
              style={{
                // transform: shouldExpandIt ? "rotate(-90deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
            />
          }
          aria-controls={`panel${location_id}-content`}
          id={`panel${loc.id}-header`}
          className="location-header"
        >
          <ExtendLocationCreativeHeader
            loc={loc}
            lc={lc}
            // locFormData={locFormData}
            // locName={locName}
            // campaign={campaign}
            // isUnsubscribed={isUnsubscribed}
            // isCreative={loc?.is_creative}
            // subscriptionStatusType={subscriptionStatusType}
          />
        </AccordionSummary>
        <AccordionDetails className="location-details">
          <Card className="w-100" elevation={2}>
            <CardContent>
              <CreativeView
                location_id={location_id}
                creatives={loc?.packages_data}
                location_name={loc?.location_name}
                can_update_creatives={lc?.can_update_creatives}
                creative_select_max_value={
                  campaignData?.creative_select_max_value || 1
                }
              />
              <OtherDetails lc={lc} />
            </CardContent>
          </Card>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default CreativeSelectionForm;
